/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
var isType = require('./is-type');

var isError = function isError(value) {
  return isType(value, 'Error');
};

module.exports = isError;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/type/is-error.js
// module id = 290
// module chunks = 0 1 2